module.exports = __webpack_public_path__ + "static/media/siemens.5186e572.png";